/** @jsx jsx */

import { Icon } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { PARTNER_CONTACT_FORM_PATH } from 'app/developer-v3/constants';

const Styles = {
  needHelpTitle: css`
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-template-columns: 20px 1fr;
    grid-column-gap: 15px;
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 16px;
    line-height: 26px;
  `,
  needHelpText: css`
    font-size: 16px;
  `,
};

export const ContactUs = () => {
  return (
    <div>
      <div css={Styles.needHelpTitle}>
        <Icon name="navHelpFill" size={20} />
        <span>Need help?</span>
      </div>
      <p css={Styles.needHelpText}>
        <Link href={PARTNER_CONTACT_FORM_PATH}>Tell us about your problem</Link>{' '}
        and we’ll connect you with the right resource or team.
      </p>
    </div>
  );
};
